import { Timestamp } from "@angular/fire/firestore";
import { Avatar } from "./avatar.model";
import { FieldsModel } from "./field.model";
import { UniversitiesFav } from "./university.model";

export interface User {
  uid?: string;
  name?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  whatsappNumber?: string;
  photoURL?: string;
  role?: string;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  firstAccess?: boolean;
  fcmToken?: string;
  tenant?: {
    id?: string;
    subdomain?: string;
    tradeName?: string;
  }
}

export interface UserStudent extends User {
  sport?: FieldsModel;
  birthDate?: Date;
  guardian?: Guardian[];
  sportsHistoryPercent?: number;
  academicHistoryPercent?: number;
  preferencesPercent?: number;
  additionalInformationPercent?: number;
  mainPosition?: FieldsModel;
  secondaryPosition?: FieldsModel;
  documentsPercent?: number;
  nationality?: string;
  instagram?: string;
  tiktok?: string;
  address?: Address;
  plan?: {
    id?: string;
    name?: string;
    pid?: string;
  };
  configProfilePercent?: number;
  configAddressPercent?: number;
  configGuardianPercent?: number;
  coins?: number;
  lessonsId?: string[];
  trackIds?: string[];
  actualPhase?: { id?: string; name?: string; startDate?: any; order?: number };
  phasesCompleted?: string[];
  xp?: number;
  talentManager?: { name?: string, photoURL?: string, uid?: string, phoneNumber?: string };
  isWhatsApp?: boolean;
  avatar?: Avatar;
  coach?: { uid?: string, name?: string; createdAt?: Timestamp },
  universitiesFav?: UniversitiesFav[],
  university?: {
    id?: string;
    name?: string;
    logo?: string;
    createdAt?: any;
    term?: string;
  };
  sponsorMe?: string;
  objective?: FieldsModel;
  activatedAccount?: boolean;
  isTalent?: boolean;
  leagues?: FieldsModel[];
  //missions Freshman
  missionsFreshManEducationalBase?: boolean
  missionsFreshManOneTrack?: boolean
  missionsFreshManSportsBase?: boolean
  missionsFreshManTrack?: boolean
  missionsSeniorNegotiation?: boolean;
  missionsSeniorI20?: boolean;
}

export interface UserCoach extends User {
  birthDate?: Date;
  nationality?: string;
  socialMedia?: string;
  university?: {
    id: string;
    name: string;
    logo?: string;
  };
  sport?: FieldsModel;
  positionNeeded?: FieldsModel[];
  favoritesUid?: string[];
  recruitedsUid?: string[];
  recruitedIds?: string[];
  lastVisitedStudent?: {
    uid?: string;
    name?: string;
  };
  lastHighlightStudent?: {
    uid: string;
    visitedDate: any;
  };
  talentManager?: { name?: string, photoURL?: string, uid?: string, phoneNumber?: string };
}

export interface UserWhiteLabel extends User {
  socialReason?: string;
  cnpj?: string;
  isWhatsApp?: boolean;
  plan?: UserPlan;
  tenantId?: string;
  jobTitle?: string;
  tenant?: Tenant;
  onboarding?: TenantUserOnboarding;
}

export interface TenantUserOnboarding {
  termsAcceptedAt?: Date | Timestamp;
  termsDocumentId?: 'pt-BR';
  termsDocumentUpdatedAt?: Date | Timestamp;
  termsContentHash?: string;
  profileCompletedAt?: Date | Timestamp;
}

export interface Tenant {
  id?: string;
  domain?: string;
  logo?: string;
  images?: Array<string>;
  colors?: {
    primary?: string;
    secondary?: string;
    tertiary?: string;
  }
}

export interface Guardian {
  name?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  whatsappNumber?: string;
  degreeOfKinship?: string;
  levelOfInstruction?: FieldsModel;
  isWhatsApp?: boolean;
}

export interface Address {
  addressName?: string;
  cep?: string;
  city?: string;
  complement?: string;
  country?: string;
  district?: string;
  number?: number;
  state?: string;
}

export enum UserRole {
  COACH = 'coach',
  STUDENT = 'student',
  ADMIN = 'admin',
  TALENT_MANAGER = 'talent_manager',
  WHITE_LABEL = 'whitelabel',
  TENANT_USER = 'tenant_user'
}

export enum UserPlan {
  FREE = 'free',
  PLACEMENT = 'placement'
}
